import DOMPurify from "isomorphic-dompurify";
import Markdown from "markdown-to-jsx/react";

import ViatorCardRow from "@/components/card/viator/ViatorCardRow";
import guideStyles from "components/guide/Guide.module.scss";
import styles from "./InfoSection.module.scss";
import SectionTitle from "./SectionTitle";

export default function InfoSection({
  title,
  text,
  icon,
  id,
  topRow,
  data,
  showViator,
  setViatorExperiences,
}) {
  // Move this to server side to avoid hydration errors

  if (!title || !text) {
    return null;
  }

  const location = data?.location ?? {};

  const searchTerms = data?.items?.map((item) => {
    if (location) {
      const { country, city } = location;

      return `${item}, ${city}, ${country}`;
    }

    return item;
  });

  return (
    <section className={`${guideStyles.section}`} id={id}>
      <SectionTitle title={title} icon={icon} />
      {topRow && topRow}
      <Markdown>{DOMPurify.sanitize(text)}</Markdown>
      {data && data?.items && showViator && (
        <div className={`${styles.viatorProducts}`}>
          <ViatorCardRow
            searchTerms={searchTerms}
            location={location}
            afterFetch={(items) => {
              if (!items) {
                return;
              }

              setViatorExperiences((prev) => {
                const uniqueItems = Array.isArray(prev)
                  ? items
                      .filter(
                        (item) =>
                          !prev.find(
                            (prevItem) =>
                              prevItem.productCode === item.productCode
                          )
                      )
                      .map((item) => {
                        return { viatorActivity: item, location };
                      })
                  : [];

                return [...prev, ...uniqueItems];
              });
            }}
            destinationId={
              location?.destinations[0]?.destination_details
                ?.viator_destination_info?.destination_id ?? null
            }
          />
        </div>
      )}
    </section>
  );
}
